require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./where-can-i-start-learning-to-code.json") })
        }
      }, "path---where-can-i-start-learning-to-code");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---where-can-i-start-learning-to-code!./.cache/json/where-can-i-start-learning-to-code.json
// module id = 1250
// module chunks = 231608221292675